import React from 'react';

import {cloneChildrenRecursively as ccr} from 'shared/helpers';

// IMPORTANT:
// When using Formation, it's best not to have too depp of a component
// tree inside it. This is because Formation traverses the whole tree
// recursively to clone the target inputs with props.


/*
 * Use this component to wrap all children inputs with 'canUseFormation' static
 * method to automate some boilerplate data bindings etc.
 *
 * 'formData' prop should be in this shape:
 * formData = {
 *   [inputName]: {
 *     value: ...,
 *     errors: [...],
 *   }
 * }
 *
 * References:
 * http://stackoverflow.com/questions/32370994/how-to-pass-props-to-this-props-children
 * http://stackoverflow.com/questions/32916786/react-children-map-recursively
 * https://gist.github.com/dandelany/1ff06f4fa1f8d6f89c5e
 * https://gist.github.com/thomaswhyyou/d9389adc505a06465e2f60a320392029
 */
class Formation extends React.Component {

  constructor(props) {
    super(props);
    // {jsonSchema, formData, onChange}

    // Using these two for cloneChildrenRecursively();
    this.filterChildForClone = this.filterChildForClone.bind(this);
    this.getMorePropsForClone = this.getMorePropsForClone.bind(this);
    this.formatLabelFromName = this.formatLabelFromName.bind(this);
  }

  filterChildForClone(child) {
    // Child should always be a valid React element.
    // Filter only for any child with 'canUseFormation' getter method.

    // Filter out native html elements or strings.
    if (typeof child === 'string') { return false; }
    if (typeof child.type === 'string') { return false; }

    // Check under 'InnerComponent' too b/c
    // JSS exposes the original component there.
    return (
      child.type.prototype.canUseFormation
      || child.type.InnerComponent.prototype.canUseFormation
    );
  }

  formatLabelFromName(name = '') {
    return name.split('_').map(s => (
      s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase()
    )).join(' ');
  }

  getMorePropsForClone(child) {
    // Child should always be a valid AND filtered react element.

    const {
      name,
      label = this.formatLabelFromName(name),
    } = child.props;

    const {
      formData: {
        [name]: {value, errors} = {},
      },
      ...props
    } = this.props;

    // Pass in the first error message.
    const _errors = Array.isArray(errors) ? errors : [];
    const errorText = _errors[0] || null;

    return {value, label, errorText, ...props};
  }

  render() {
    const {children} = this.props;

    return (
      <form>
        {ccr(children, {}, this.filterChildForClone, this.getMorePropsForClone)}
      </form>
    );
  }
}

// export function initFormDataBySchema(schema) {
//   const inputNames = Object.keys(schema.properties);

//   // For now, assume only one level down.

//   return inputNames.reduce((formData, inputName) => (
//     Object.assign({}, formData, {
//       [inputName]: {
//         value: '',
//         errors: [],
//       }
//     })
//   ), {});
// };
// Formation.initFormDataBySchema = initFormDataBySchema;


// export function repackFormDataByKey(formData) {
//   const inputNames = Object.keys(formData);
//   const repacked = {formDataVal: {}, formDataErr: {}};

//   return inputNames.reduce((repacked, inputName) => {
//     const {value, errors} = formData[inputName];
//     const formDataVal = {...repacked.formDataVal, [inputName]: value};

//     const formDataErr = (errors.length === 0 ?
//       repacked.formDataErr :
//       {...repacked.formDataErr, [inputName]: errors}
//     );
//     // const formDataErr = {...repacked.formDataErr, [inputName]: errors};
//     return {formDataVal, formDataErr};
//   }, repacked);
// };
// Formation.repackFormDataByKey = repackFormDataByKey;


export default Formation;



// WEBPACK FOOTER //
// ./src/components/utils/Formation.js